import styled from 'styled-components';

export const StyledExploreLocations = styled.div`
  &.explore-locations {
    /* Top accordion */
    .locations-list-accordion {
      display: flex;
      align-items: center;
      position: relative;
      background-color: transparent;
      color: var(--color-black);
      width: 100%;
      text-align: left;
      margin-top: 20px;
      margin-bottom: 0;
      padding-bottom: 25px;
      padding-left: 0;
      border: 0;
      cursor: pointer;
    }

    .locations-list-accordion.active {
      border-bottom: 1px solid var(--color-black);
    }

    .locations-list-accordion.not-active::after {
      content: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIyNXB4IiB2aWV3Qm94PSIwIDAgMjYgMjUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+R3JvdXAgMTM8L3RpdGxlPgogICAgPGcgaWQ9IlVuaWNlZi1TdWItUGFnZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkxvdmUtVHJhdmVscy0tLVVuaWNlZi0tLURlc2t0b3AtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEzMDcsIC0zNjI0KSIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNywgMzQzNikiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjMzMjYsIDE3NikiPgogICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC0zNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIwMC42MDIzLCAxMikiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLCAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8bGluZSB4MT0iMTIuOTg2OTUiIHkxPSIwIiB4Mj0iMTIuOTg2OTUiIHkyPSIyNC45NzQiIGlkPSJQYXRoLTkiPjwvbGluZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIwIiB5MT0iMTIuNDg3MDUiIHgyPSIyNC45NzQiIHkyPSIxMi40ODcwNSIgaWQ9IlBhdGgtOSI+PC9saW5lPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=');
      position: absolute;
      width: 26px;
      height: 46px;
      right: 7px;
    }

    .locations-list-accordion.active::after {
      content: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjZweCIgaGVpZ2h0PSIzcHgiIHZpZXdCb3g9IjAgMCAyNiAzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPlBhdGggOTwvdGl0bGU+CiAgICA8ZyBpZD0iVW5pY2VmLVN1Yi1QYWdlIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTG92ZS1UcmF2ZWxzLS0tVW5pY2VmLS0tRGVza3RvcC0yLUV4cGFuZGVkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMwNywgLTM2MzUpIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0xOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA3LCAzNDM2KSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMzMyNiwgMTc2KSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTM3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjAwLjYwMjMsIDIzLjk4NykiPgogICAgICAgICAgICAgICAgICAgICAgICA8bGluZSB4MT0iMCIgeTE9IjAuNSIgeDI9IjI0Ljk3NCIgeTI9IjAuNSIgaWQ9IlBhdGgtOSI+PC9saW5lPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+');
      position: absolute;
      right: 7px;
    }

    /* List container */
    .locations-list {
      display: none;
    }

    .locations-list.is-open {
      display: block;
    }

    /* Location rows */
    .locations-list .location:not(:last-child) {
      border-bottom: 1px solid;
    }

    /* Location accordion */

    .locations-list .location-accordion {
      font: inherit !important;
      font-family: var(--font-sans-serif) !important;
      font-size: 26px !important;
      font-weight: 500 !important;
      color: var(--color-black);
      line-height: 18px !important;
      letter-spacing: -0.72px;
      display: flex;
      align-items: center;
      position: relative;
      background-color: transparent;
      width: 100%;
      text-align: left;
      padding-top: 25px;
      padding-left: 0;
      padding-bottom: 25px;
      border: 0;
      cursor: pointer;
    }

    .locations-list .location-accordion::after {
      content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxNiAxMCI+CiAgPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI5LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDIuMS4wIEJ1aWxkIDE5MikgIC0tPgogIDxnIGlkPSJVbmljZWYtU3ViLVBhZ2UiPgogICAgPGcgaWQ9IkxvdmUtVHJhdmVscy0tLVVuaWNlZi0tLURlc2t0b3AtMi1FeHBhbmRlZCI+CiAgICAgIDxnIGlkPSJHcm91cC0yOSI+CiAgICAgICAgPGcgaWQ9IlBhdGgtMTEiPgogICAgICAgICAgPHBvbHlnb24gcG9pbnRzPSIxNC4zIC40IDE1LjcgMS45IDggOS42IC4zIDEuOSAxLjcgLjQgOCA2LjcgMTQuMyAuNCIvPgogICAgICAgIDwvZz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+');
      position: absolute;
      right: 0;
      width: 12px;
    }

    .locations-list .location-accordion.active::after {
      content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxNiAxMCI+CiAgPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI5LjAuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDIuMS4wIEJ1aWxkIDE5MikgIC0tPgogIDxnIGlkPSJVbmljZWYtU3ViLVBhZ2UiPgogICAgPGcgaWQ9IkxvdmUtVHJhdmVscy0tLVVuaWNlZi0tLURlc2t0b3AtMi1FeHBhbmRlZCI+CiAgICAgIDxnIGlkPSJHcm91cC0yOSI+CiAgICAgICAgPGcgaWQ9IlBhdGgtMTEiPgogICAgICAgICAgPHBvbHlnb24gcG9pbnRzPSIxLjcgOS42IC4zIDguMSA4IC40IDE1LjcgOC4xIDE0LjMgOS42IDggMy4zIDEuNyA5LjYiLz4KICAgICAgICA8L2c+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPg==');
      position: absolute;
      right: 0;
      width: 12px;
    }

    /* Location accordion panel */
    .locations-list .location .location-accordion-links {
      display: none;
      padding-top: 35px;
      padding-bottom: 35px;
    }

    .locations-list .location .location-accordion-links.is-open {
      display: flex;
    }

    /* Items */
    .locations-list .location .location-accordion-links .location-item {
      font-family: var(--font-sans-serif);
      font-size: 16px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.5px;
      color: var(--color-black);
      display: flex;
      flex-direction: column;
      height: 100%;
      list-style-type: none;
    }

    .locations-list .location .location-accordion-links .location-item .location-item-region {
      padding-bottom: 10px;
    }

    .locations-list .location .location-accordion-links .location-item .location-item-wrapper {
      padding: 0;
    }

    .locations-list .location .location-accordion-links .location-item .location-item-link {
      display: flex;
      align-items: center;
      position: relative;
      width: fit-content;
      -moz-width: fit-content;
      font-family: var(--font-sans-serif);
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
      letter-spacing: normal;
      color: var(--color-gray);
      transition: all 0.2s ease;
      padding-bottom: 12px;
      text-decoration: none;
    }

    .locations-list .location .location-accordion-links .location-item .location-item-link:hover {
      color: var(--color-black);
    }

    .locations-list .location .location-accordion-links .location-item .location-item-link::after {
      content: '';
      position: absolute;
      right: -12px;
      background-color: var(--color-gray-light);
      width: 6px;
      height: 6px;
      border-left: 2px solid;
      border-bottom: 2px solid;
      transform: rotate(225deg);
    }
  }
`;
